import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import Image from 'react-retina-image';

import styles from './Footer.module.scss';
import { BRAND } from '../../constants/brand';
import {
  Container,
  Heading,
  Hidden,
  InstaFeed,
  Link,
  List,
  ListItem,
} from '..';
import { LIST_TYPE_TOOTH } from '../../constants/list';
import { INSTA_USERNAME } from '../../constants/insta';
import { BOOKING_LINK } from '../../constants/booking';

interface FooterProps {
  className?: string;
}

const Footer: FunctionComponent<FooterProps> = ({ className }) => {
  const footerClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-footer`,
    className,
    {
      [styles.footer]: true,
    },
  );

  return (
    <>
      <section className={styles.dentalCouncil}>
        <Container>
          <Heading level={2}>You&apos;re in safe hands</Heading>
          <List>
            <ListItem type={LIST_TYPE_TOOTH}>
              Fully insured and qualified
            </ListItem>
          </List>
        </Container>
      </section>
      <section className={styles.insta}>
        <Container>
          <Heading level={2}>#CrystalCanine</Heading>
        </Container>
        <InstaFeed account={INSTA_USERNAME} />
      </section>
      <footer className={footerClass}>
        <nav aria-label="Footer navigation">
          <ul>
            <li className={styles.hr}>
              <Link noStyles to="/">
                <Hidden>Home</Hidden>
                <Image src="/images/logo.png" alt="Crystal Canine" />
              </Link>
            </li>
            <li>
              <Link className={styles.hover} noStyles to="/contact">
                Contact
              </Link>
            </li>
            <li>
              <Link
                className={styles.hover}
                noStyles
                external
                to={BOOKING_LINK}
              >
                Booking
              </Link>
            </li>
            <li>
              <Link className={styles.hover} noStyles to="/faq">
                FAQ
              </Link>
            </li>
            <li>
              <Link className={styles.hover} noStyles to="/training">
                Training Courses
              </Link>
            </li>
            <li>
              <Link className={styles.hover} noStyles to="/prices">
                Price List
              </Link>
            </li>
          </ul>
        </nav>
      </footer>
    </>
  );
};

export default Footer;
